import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthStorageService, RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from 'src/app/service/storage/storage.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../asm/asm-constant';

@Injectable({
  providedIn: 'root',
})
export class UnitSelectionGuard implements CanActivate {
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  constructor(
    private routingService: RoutingService,
    protected authStorageService: AuthStorageService,
    private storageService: StorageService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authStorageService.getToken().pipe(
      map((token) => {
        if (token.access_token) {
          let b2bunitSelected = this.storageService.getLocalStorageItem('shimanoSessionB2BUnit') ? true : false;
          let unitSelectionEnabled = this.storageService.getLocalStorageItem('shimanoSessionB2BUnit_enabled');
          let shimanoSessionB2BUnit_enabled = unitSelectionEnabled === 'true';
          if (this.asmEnabled || !shimanoSessionB2BUnit_enabled || b2bunitSelected) {
            this.routingService.go({ cxRoute: 'home' });
            return false;
          }
          return true;
        }
        return !token.access_token;
      })
    );
  }
}
